import { useNavigate } from 'react-router-dom'
import { RhyBusUserProfile } from '@rhybus/user-profile'
import { useProfilePage } from '../../services/profile'
import PageOverlay from '../../utils/controls/pageoverLay/pageoverLay'

export default function Profile() {
  const navigate = useNavigate()
  const {
    data,
    isEdit,
    profileKey,
    schema,
    peopleSuggestions,
    handleChange,
    handleSelect,
    handleProfileSubmit,
    handleNotificationSubmit,
    loading,
  } = useProfilePage()

  return (
    <main id="main-content">
      {loading && <PageOverlay />}
      <h1 className="sr-only">User Profile</h1>
      <RhyBusUserProfile
        key={profileKey}
        schema={schema}
        data={data}
        isEdit={isEdit}
        peopleSuggestions={peopleSuggestions}
        onChange={handleChange}
        onSelect={handleSelect}
        onProfileSubmit={handleProfileSubmit}
        onNotificationSubmit={handleNotificationSubmit}
        onCancel={() => navigate(-1)}
      />
    </main>
  )
}
